import * as React from 'react';
import { Container, Spacer } from '@nextui-org/react';

import { useSession } from 'next-auth/react';
import { AppUnauthorized } from '@src/layouts/app/AppUnauthorized';
import { AllFriends } from '@src/layouts/friends/AllFriends';
import { InviteFriend } from '@src/layouts/friends/InviteFriend';

interface FriendsPageProps {}

/**
 * @name FriendsPage
 * @description The FriendsPage page.
 */
export default function FriendsPage(_props: FriendsPageProps) {
  // const { } = props;

  // Hooks
  const { data: session, status } = useSession();

  // Setup
  const email = session?.user?.email;

  if (status === 'unauthenticated' || !email) {
    return <AppUnauthorized />;
  }

  return (
    <Container xs gap={0}>
      <Spacer />
      <InviteFriend />
      <AllFriends />
    </Container>
  );
}
